import React, { createContext, useState, useContext, useEffect } from "react";
import { useAuth } from "../hooks";

// Creamos el contexto
const SiteContext = createContext();

// Proveedor del contexto
export const SiteProvider = (props) => {
  const { children } = props;
  const { user } = useAuth();
  const [site, setSite] = useState(() => {
    const storedSite = localStorage.getItem("site");
    return storedSite ? storedSite : "";
  }); // Estado inicial del idioma, por defecto ''

  const changeSite = (newSite) => {
    //console.log(2)
    setSite(newSite);
  };

  useEffect(() => {
    //console.log("cambiop de site", site)
    localStorage.setItem("site", site);
  }, [site]);

  // Resetear cuando el usuario cierra sesión, cargar desde localStorage al iniciar
  useEffect(() => {
    if (user) {
      const stored = localStorage.getItem("site");
      if (stored) {
        setSite(stored);
      }
    } else {
      setSite("");
    }
  }, [user]);

  return (
    <SiteContext.Provider value={{ site, changeSite }}>
      {children}
    </SiteContext.Provider>
  );
};

// Hook personalizado para consumir el contexto
export const useSite = () => {
  const context = useContext(SiteContext);
  if (!context) {
    throw new Error("useSitio debe ser usado dentro de un SitioProvider");
  }
  return context;
};
